module.exports = __webpack_public_path__ + "img/image7.fd1546f1.jpg";